import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class BillingErrorResponse {
    hasInvalidServiceStatus() {
        return this.error.hasErrorMessageIncluding('invalid service status');
    }
    isServiceLineAmountOverLimit() {
        var _this_error_context;
        return this.error.hasServerError(ServerError.ServiceLineAmountExceedsLimit) || this.error.hasServerError(ServerError.TotalsPreviewRequestInvalid) && ((_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.reason) === ServerError.ServiceLineAmountExceedsLimit;
    }
    isStaleBillingData() {
        return this.hasInvalidServiceStatus() || this.error.hasServerError([
            ServerError.MaxChargesExceeded,
            ServerError.RelationshipNotBillable
        ]);
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
